import { FileDescriptor } from "@archipad-js/core/utils";
import {
    AttachmentDelete,
    AttachmentUpdate,
    EntityCreate,
    EntityDelete,
    EntityUpdate,
    Patch,
    PatchHeader,
    PatchUserInfo,
} from "./patch.types";

export class MutablePatch implements Patch {
    /** patch header */
    header: PatchHeader;
    /** entity operations by entity type name */
    operationsByType: Map<string, MutableEntityOperations>;

    constructor(header: PatchHeader) {
        this.header = header;
        this.operationsByType = new Map<string, MutableEntityOperations>();
    }
}

export class MutablePatchHeader {
    /** minimum model version required to read this patch */
    modelMinVersion: number;
    /** model version of this patch */
    modelVersion: number;
    /** client name */
    clientName?: string;
    /* user info */
    user?: PatchUserInfo;
    /* temp patch */
    temp: boolean;
    /* if true, represent an empty patch from a regular patch point of view but is not as a temp patch */
    emptyLike: boolean;

    constructor() {
        this.modelMinVersion = null;
        this.modelVersion = null;
        this.clientName = null;
        this.user = null;
        this.temp = false;
    }
}

export class MutableEntityOperations {
    constructor() {
        this.operationById = new Map<string, MutableEntityOperation>();
    }

    /** entity operations by entity id */
    readonly operationById: Map<string, MutableEntityOperation>;
}

export class MutableAttachmentUpdate implements AttachmentUpdate {
    file: FileDescriptor;
    readonly deleted: false;

    constructor(file: FileDescriptor) {
        this.file = file;
        this.deleted = false;
    }
}

export class MutableAttachmentDelete implements AttachmentDelete {
    readonly deleted: true;

    constructor() {
        this.deleted = true;
    }
}

export type MutableAttachmentOperation = MutableAttachmentUpdate | MutableAttachmentDelete;

export class MutableEntityUpdate implements EntityUpdate {
    readonly type: "update";
    readonly propertyUpdates: Map<string, any>;
    readonly attachmentUpdates: Map<string, MutableAttachmentOperation>;

    constructor() {
        this.type = "update";
        this.propertyUpdates = new Map<string, any>();
        this.attachmentUpdates = new Map<string, MutableAttachmentOperation>();
    }
}

export class MutableEntityCreate implements EntityCreate {
    readonly type: "create";
    readonly propertyUpdates: Map<string, any>;
    readonly attachmentUpdates: Map<string, MutableAttachmentOperation>;

    constructor() {
        this.type = "create";
        this.propertyUpdates = new Map<string, any>();
        this.attachmentUpdates = new Map<string, MutableAttachmentOperation>();
    }
}

export class MutableEntityDelete implements EntityDelete {
    readonly type: "delete";

    constructor() {
        this.type = "delete";
    }
}

export type MutableEntityOperation = MutableEntityUpdate | MutableEntityCreate | MutableEntityDelete;
